import { render, staticRenderFns } from "./M3.vue?vue&type=template&id=5428640b&scoped=true&"
import script from "./M3.vue?vue&type=script&lang=js&"
export * from "./M3.vue?vue&type=script&lang=js&"
import style0 from "./M3.vue?vue&type=style&index=0&id=5428640b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5428640b",
  null
  
)

export default component.exports